import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'approvePaymentModal.modalTitle',
    defaultMessage:
      'HUD-52670 Part III: Breakdown of Assistance Payment Requested and Approved',
  },
  modalSubtitle: {
    id: 'approvePaymentModal.modalSubtitle',
    defaultMessage:
      'The Approved Amounts default to match the Requested totals. ' +
      'Enter the CA/HUD approved totals below from the voucher. \n' +
      'If there are any differences, ' +
      'you must update the Approved Amount on the applicable entries before proceeding. ' +
      'The voucher cannot be approved until all variances are resolved.',
  },
  approvePayment: {
    id: 'approvePaymentModal.approvePayment',
    defaultMessage: 'Approve Payment',
  },
  approvePaymentDisabledTooltip: {
    id: 'approvePaymentModal.approvePaymentDisabledTooltip',
    defaultMessage:
      'Voucher must be submitted before this action can be taken.',
  },
  voucherIdLabel: {
    id: 'approvePaymentModal.voucherIdLabel',
    defaultMessage: 'Voucher ID',
  },
  voucherIdInvalid: {
    id: 'approvePaymentModal.voucherIdInvalid',
    defaultMessage: 'Must enter a valid Voucher ID #',
  },
  voucherIdFormat: {
    id: 'approvePaymentModal.voucherIdFormat',
    defaultMessage: 'Voucher ID must be up to 10 digits',
  },
  typeOfAssistance: {
    id: 'approvePaymentModal.typeOfAssistance',
    defaultMessage: 'Type of Assistance',
  },
  unitsInBilling: {
    id: 'approvePaymentModal.unitsInBilling',
    defaultMessage: '# of Units in Billing',
  },
  requestedAmount: {
    id: 'approvePaymentModal.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  amountApproved: {
    id: 'approvePaymentModal.amountApproved',
    defaultMessage: 'Amount Approved',
  },
  caHudApprovedAmount: {
    id: 'approvePaymentModal.caHudApprovedAmount',
    defaultMessage: 'CA/HUD Approved Amount',
  },
  variance: {
    id: 'approvePaymentModal.variance',
    defaultMessage: 'Variance',
  },
  regularTenantAssistance: {
    id: 'approvePaymentModal.regularTenantAssistance',
    defaultMessage: 'Regular Tenant Asst. Payments',
  },
  adjustments: {
    id: 'approvePaymentModal.adjustments',
    defaultMessage: 'Adjustments',
  },
  specialClaims: {
    id: 'approvePaymentModal.specialClaims',
    defaultMessage: 'Special Claims',
  },
  miscAccounting: {
    id: 'approvePaymentModal.miscAccounting',
    defaultMessage: 'Misc. Accounting',
  },
  repaymentAgreements: {
    id: 'approvePaymentModal.repaymentAgreements',
    defaultMessage: 'Repayment Agreements',
  },
  total: {
    id: 'approvePaymentModal.total',
    defaultMessage: 'Total',
  },
  saveAndClose: {
    id: 'approvePaymentModal.saveAndClose',
    defaultMessage: 'Save & Close',
  },
  confirmAndFinalize: {
    id: 'approvePaymentModal.confirmAndFinalize',
    defaultMessage: 'Confirm & Finalize',
  },
  confirmationBanner: {
    id: 'approvePaymentModal.confirmationBanner',
    defaultMessage:
      'Your Voucher is ready to be finalized! Click Confirm & Finalize below to complete the approval of this Voucher.',
  },
  varianceErrorBanner: {
    id: 'approvePaymentModal.varianceErrorBanner',
    defaultMessage:
      'There is a variance on this voucher. You must go to the bucket(s) with the variance & update ' +
      'the Approved Amount on the applicable entry or entries to match the HUD/CA Approved Amount. ' +
      'Once there are no more variance(s) showing in the buckets, you can approve this Voucher. ' +
      'Click Save & Close below.',
  },
  caHudMaxDecimals: {
    id: 'approvePaymentModal.caHudMaxDecimals',
    defaultMessage: 'Max 2 decimal places',
  },
  toastrSaveSuccess: {
    id: 'approvePaymentModal.toastrSaveSuccess',
    defaultMessage: 'Approval data saved successfully.',
  },
  toastrFinalizeSuccess: {
    id: 'approvePaymentModal.toastrFinalizeSuccess',
    defaultMessage: 'Voucher has been finalized and approved.',
  },
  toastrError: {
    id: 'approvePaymentModal.toastrError',
    defaultMessage: 'Failed to save approval data. Please try again.',
  },
});
